import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import downloadbtn from './../img/downloadbtn.png'
import Api from "../common/api";

const Logos = () => {

  const [logos, setLogos] = useState([])
  const lang = localStorage.getItem("lang");
  const [activePath, setActivePath] = useState(useLocation().pathname.split("/")[2]);
  const [currentTab, setCurrentTab] = useState([]);
  React.useEffect(() => {
    Api.get("/Documents/list/9").then((res) => {
      setLogos(res.data.items)
      setCurrentTab(res.data.items[res.data.items.findIndex(x => x.Link == activePath)])
    });
  }, []);

  return (
    <div className="logos-container container-sm">
      {logos ? logos.map((logo) => {
        return (
        lang == "en" ? (
          logo.Name_EN ? (
        <>
            <div className="logo-container item-item">
              <img src={downloadbtn} alt={logo.Name_EN} />
              <div className="yazi-part">
                <h4>{logo.Name_EN}</h4>
                <a href={'https://sankoenerji.com.tr' + logo.File_En} download={'https://sankoenerji.com.tr' + logo.File_En} target="_blank" className="bold-download-btn">Click to download</a>
              </div>
            </div>
          </>
          ):""
          ):(
            logo.Name_TR ? (
          <>
            <div className="logo-container item-item">
              <img src={downloadbtn} alt={logo.Name_TR} />
              <div className="yazi-part">
                <h4>{logo.Name_TR}</h4>
                <a href={'https://sankoenerji.com.tr' + logo.Image} download={'https://sankoenerji.com.tr' + logo.Image} target="_blank" className="bold-download-btn">İndirmek için tıklayınız</a>
              </div>
            </div>
          </>
          ):""
          )
        )
      }) : null}
    </div>
  )
}

export default Logos
